export default __webpack_public_path__ + "static/media/library_logo.9664bccc.png";